import React from "react";
import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  canonicalPath?: string;
  image?: string;
  noindex?: boolean;
}

const SITE_URL = "https://myonlineshopping.co.in";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonicalPath = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
}) => {
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;
  const robots = noindex ? "noindex, follow" : "index, follow, max-image-preview:large";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="MyOnlineShopping" />
      <meta property="og:image" content={image || DEFAULT_IMAGE} />
      <meta property="og:image:alt" content={title} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default SEO;
